import React from 'react'
import strings from '../../../lang/strings'

export default function TableHeaderPrimary(props) {
  return (
    <div className={'tb-header-primary ' + props.className}>
      {
        props.headers.map((item, index) => {
          return item.is_team === undefined ? (
            <div key={index} className={'d-flex align-items-center fs-16 sm-fs-14 f-m ' + item.class}>
              <div className={item.center === false ? 'flex-full' : 'flex-full text-center'}>
                {
                  item.is_win_lose != true ? item.name : (
                  <div className='d-flex justify-content-center f-sb'>
                    <div className='ml-12 sm-ml-7 fls12 sm-fls9'>{strings.win_lose}</div>
                  </div>
                  )
                }

              </div>
              {
                item.divider !== false &&
                <div className='th-divider'/>
              }
            </div>
          ) : (
            <div key={index} className={'d-center ' + item.class}>
              <div className='flex-full d-center'>
                <div className={'fs-16 sm-fs-14 f-sb'}>{strings.team1}</div>
                <img className='im-vs mh-4' src={'/assets/image/vs.png'} alt='' />
                <div className={'fs-16 sm-fs-14 f-sb'}>{strings.team2}</div>
              </div>
              {
                item.divider !== false &&
                <div className='th-divider'/>
              }
            </div>
          )
        })
      }
    </div>
  )
}
